import React from "react";
import { useStoreState } from "../hooks/ep";
import {
  useEnsureActionReportsData,
  useEnsureTripNotesData,
} from "../helpers/useEnsureData";
import AgTable from "./AgTable";
import "styled-components/macro";
import { Spinner } from "@blueprintjs/core";
import { useColDefs } from "./opps-table-coldefs";
import { ReportActionModalWrapper } from "./reporting-actions/modal-or-drawer";
import { PLANNER__COLDEF } from "./common-coldefs";
import _ from "lodash"; // DO NOT REMOVE. Necessary for using the css={`...`} prop

function TableInner() {
  const rowData = useStoreState((s) => s.actionReports.suspendsRowData);
  rowData.forEach((row) => {
    row.id = ["TripId", "leg_i"].map((k) => row[k]).join(".");
  });
  const colDefs = [PLANNER__COLDEF, ...useColDefs("suspends", rowData)];

  return (
    <>
      <AgTable rowData={rowData} columnDefs={colDefs} tableName="suspends" />
      <ReportActionModalWrapper />
    </>
  );
}

export function SuspendsTable() {
  const loading = [useEnsureActionReportsData(), useEnsureTripNotesData()];
  return _.max(loading) ? <Spinner /> : <TableInner />;
}
